// Product condition options
export const CONDITION_OPTIONS = [
  // { value: '', label: 'Select condition...' },
  { value: 'new_with_tags', label: 'New with tags' },
  { value: 'new_without_tags', label: 'New without tags' },
  { value: 'like_new', label: 'Like new' },
  { value: 'very_good', label: 'Very good' },
  { value: 'good', label: 'Good' },
  { value: 'fair', label: 'Fair' }
]; 